export const en = {
  common: {
    language: "Language",
    dashboard: "Dashboard",
    events: "Events",
    statistics: "Statistics",
    persons: "Persons",
    hotels: "Hotels",
    flights: "Flights",
    buses: "Buses",
    cars: "Cars",
    trains: "Trains",
    eventSchedule: "Event Schedule",
    eventMap: "Event Map",
    hotelReservations: "Hotel Reservations",
    eventExpenses: "Event Expenses",
    allEvents: "All Events",
    loading: "Loading...",
    edit: "Edit",
    create: "Create",
    delete: "Delete",
    cancel: "Cancel",
    save: "Save",
    details: "Details",
    actions: "Actions",
    view: "View",
    new: "New",
    search: "Search",
    noResults: "No results found",
    selectEvent: "Select Event",
    pleaseSelectEventFirst: "Please select an event first",
    error: "Error",
    seat: "Seat",
    seats: "Seats",
    confirmation: "Confirmation",
    notes: "Notes",
    passenger: "Passenger",
    addTicket: "Add Ticket",
    company: "Company",
    departure: "Departure",
    arrival: "Arrival",
    capacity: "Capacity",
    success: "Success",
    ticketDeletedSuccessfully: "Ticket deleted successfully",
    couldNotDeleteTicket: "Could not delete ticket",
    profile: "Profile",
    myProfile: "My Profile",
    logout: "Logout",
    saveChanges: "Save Changes",
  },
  dashboard: {
    title: "Dashboard",
    stats: {
      persons: "Persons",
      hotels: "Hotels",
      flights: "Flights",
      buses: "Buses"
    }
  },
  persons: {
    name: "Name",
    email: "Email",
    phone: "Phone",
    role: "Role",
    createPerson: "Create Person",
    editPerson: "Edit Person",
    personDetails: "Person Details",
    personItinerary: "Person Itinerary",
    accommodation: "Accommodation",
    travelTimeline: "Travel Timeline"
  },
  events: {
    name: "Name",
    startDate: "Start Date",
    endDate: "End Date",
    location: "Location",
    description: "Description",
    createEvent: "Create Event",
    editEvent: "Edit Event"
  },
  hotels: {
    name: "Name",
    address: "Address",
    city: "City",
    country: "Country",
    createHotel: "Create Hotel",
    editHotel: "Edit Hotel"
  },
  flights: {
    flightNumber: "Flight Number",
    airline: "Airline",
    departureAirport: "Departure Airport",
    arrivalAirport: "Arrival Airport",
    departureDate: "Departure Date",
    arrivalDate: "Arrival Date",
    createFlight: "Create Flight",
    editFlight: "Edit Flight",
    flightDetails: "Flight Details",
    passengers: "Passengers"
  },
  buses: {
    busNumber: "Bus Number",
    busDetails: "Bus Details",
    company: "Company",
    departureLocation: "Departure Location",
    arrivalLocation: "Arrival Location",
    departureDate: "Departure Date",
    arrivalDate: "Arrival Date",
    createBus: "Create Bus",
    editBus: "Edit Bus",
    departure: "Departure",
    arrival: "Arrival",
    capacity: "Capacity",
    passengers: "Passengers"
  },
  cars: {
    licensePlate: "License Plate",
    model: "Model",
    brand: "Brand",
    color: "Color",
    createCar: "Create Car",
    editCar: "Edit Car",
    carDetails: "Car Details",
    driver: "Driver",
    passengers: "Passengers"
  },
  trains: {
    trainNumber: "Train Number",
    company: "Company",
    departureStation: "Departure Station",
    arrivalStation: "Arrival Station",
    departureDate: "Departure Date",
    arrivalDate: "Arrival Date",
    createTrain: "Create Train",
    editTrain: "Edit Train",
    trainDetails: "Train Details",
    passengers: "Passengers"
  },
  profile: {
    profileSettings: "Profile Settings",
    manageProfile: "Manage your personal information and account settings",
    name: "Name",
    email: "Email",
    phone: "Phone",
    role: "Role",
    yourName: "Your name",
    yourEmail: "Your email",
    yourPhone: "Your phone number",
    mustBeLoggedIn: "You must be logged in to view your profile",
    profileUpdated: "Profile updated",
    profileUpdateSuccess: "Your profile has been successfully updated",
    couldNotUpdateProfile: "Could not update your profile"
  }
}; 